export default function BentonvilleTravelTimingSection() {
  return (
    <section id="timing" className="bg-[#F7F8FA] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Travel Timing</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Best Times to Apply from Bentonville</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { season: "Spring (Mar–May)", tag: "Corporate Season", desc: "Walmart quarterly supplier reviews and global category planning meetings. Apply 8 weeks before planned travel. Family spring break demand peaks." },
            { season: "Summer (Jun–Aug)", tag: "High Demand", desc: "Peak family vacation and corporate retreat season. Back-to-school shopping visits to global suppliers. Start your application early." },
            { season: "Fall/Winter (Sep–Feb)", tag: "Best Processing", desc: "Fastest government processing times. Q4 Walmart global holiday merchandise season. Holiday family travel and New Year cruises." },
          ].map((t) => (
            <div key={t.season} className="bg-white rounded-lg p-6 border border-gray-200">
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-bold text-[#1A365D] text-lg">{t.season}</h3>
                <span className="text-xs font-semibold bg-[#EEF2F8] text-[#1A365D] px-2 py-1 rounded-full whitespace-nowrap">{t.tag}</span>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}